import { useEffect, type ReactNode } from "react";
import { config } from "../../utils/tenantConfig";
import { applyTenantTheme } from "../../theme/applyTenantTheme";

const LINK_ATTR = "data-tenant-stylesheet";

/**
 * Applies tenant theme (CSS variables + optional font stylesheets) once on mount.
 */
export function TenantThemeApplier({ children }: { children: ReactNode }) {
	useEffect(() => {
		const theme = config.theme;
		const created: HTMLLinkElement[] = [];

		for (const href of theme.fonts.externalStylesheetUrls) {
			const already = Array.from(
				document.querySelectorAll<HTMLLinkElement>(`link[${LINK_ATTR}]`)
			).find((el) => el.getAttribute("href") === href);
			if (already) {
				continue;
			}
			const link = document.createElement("link");
			link.rel = "stylesheet";
			link.href = href;
			link.setAttribute(LINK_ATTR, "true");
			document.head.appendChild(link);
			created.push(link);
		}

		applyTenantTheme(theme);

		return () => {
			created.forEach((link) => link.remove());
		};
	}, []);

	return <>{children}</>;
}
